import { TradingModal } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { CreatePlantPayload, User } from '@/interfaces';

import CompanyCupsForm from '../forms/CompanyCupsForm';

import usePlantForm from '../../hooks/utils/usePlantForm';

type Props = {
  setIsOpen: (isOpen: boolean) => void;
  companyUsers: User[];
  handleCreatePlant: (payload: CreatePlantPayload) => Promise<void> | void;
  companyId: number;
};

export default function CreateCompanyCupsModal({ setIsOpen, companyUsers, handleCreatePlant, companyId }: Props) {
  const { t } = useTranslation();

  const { form, isSubmitting, errors, updateField, updateUsers, handleSubmit } = usePlantForm({
    onSubmit: async (payload) => {
      await handleCreatePlant(payload);
      setIsOpen(false);
    },
    companyId,
  });

  return (
    <TradingModal
      titleText={t('settings.companyDetailsTab.companyCups.modal.createCupsTitle')}
      bodyText={
        <CompanyCupsForm
          form={form}
          isSubmitting={isSubmitting}
          errors={errors}
          companyUsers={companyUsers}
          updateField={updateField}
          updateUsers={updateUsers}
          handleSubmit={handleSubmit}
          type="create"
        />
      }
      open
      onClose={() => setIsOpen(false)}
      styleModal={{
        minHeight: '35%',
        overflow: 'visible',
      }}
      shouldCloseOnBackdropClick={false}
    />
  );
}
